import { useTranslations } from 'next-intl'
import Image from 'next/image'
import logo from './logo.svg'
import logoHg from './logo-hg.svg'

export const Logo = ({ locale }: { locale: string }) => {
  const t = useTranslations('Logo')

  return (
    <Image
      alt={t('alt')}
      className='h-[theme(height.header-mobile)] w-auto py-3 lg:h-[theme(height.header-desktop)]'
      height='95'
      priority
      src={['de-ch', 'es'].includes(locale) ? logoHg : logo}
      width='221'
    />
  )
}
